import {
	SET_THERMOBOX_INFO,
	SET_IS_THERMOBOX_INFO_LOADING,
	SET_IS_THERMOBOX_CREATING,
	SET_IS_THERMOBOX_UPDATING,
	SET_IS_THERMOBOX_DELETING,
	SET_PARTNERS,
	SET_IS_PARTNERS_LOADING,
	RESET_STATE,
} from './actions';

export const initialState = {
	thermoboxInfo: null,
	isThermoboxInfoLoading: false,
	isThermoboxCreating: false,
	isThermoboxUpdating: false,
	isThermoboxDeleting: false,
	partners: [],
	isPartnersLoading: false,
};

const thermoboxModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_THERMOBOX_INFO:
			return { ...state, thermoboxInfo: payload };
		case SET_IS_THERMOBOX_INFO_LOADING:
			return { ...state, isThermoboxInfoLoading: payload };
		case SET_IS_THERMOBOX_CREATING:
			return { ...state, isThermoboxCreating: payload };
		case SET_IS_THERMOBOX_UPDATING:
			return { ...state, isThermoboxUpdating: payload };
		case SET_IS_THERMOBOX_DELETING:
			return { ...state, isThermoboxDeleting: payload };
		case SET_PARTNERS:
			return { ...state, partners: payload };
		case SET_IS_PARTNERS_LOADING:
			return { ...state, isPartnersLoading: payload };
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default thermoboxModalReducer;
